// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h2[data-v-1554f3e8]{font-family:realistnarrow,sans-serif;font-weight:900}", "",{"version":3,"sources":["webpack://./src/components/formAnnualTax/ThankYouPage.vue"],"names":[],"mappings":"AACA,oBACE,oCAAA,CACA,eAAA","sourcesContent":["\nh2 {\n  font-family: realistnarrow, sans-serif;\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
